<template>
	<div class="landing-page-container">
		<section class="section">
			<h3 class="title">{{ $t('controlPanel.landingPage.changeVersion') }}</h3>
			<Hint
				:hint="$t('controlPanel.landingPage.autoCleanCacheHint')"
				:label="$t('controlPanel.landingPage.autoCleanCacheLabel')"
			/>
			<button @click="update" class="app-version-button">{{ $t('controlPanel.landingPage.updateVersionButton') }}</button>
		</section>
		<section class="section">
			<h3 class="title">{{ $t('controlPanel.landingPage.imageUploadTitle') }}</h3>
			<ImageUpload
				:title="`${$t('controlPanel.landingPage.imageUploadTitle')}`"
				:hint="`${$t('controlPanel.landingPage.imageHint')}`"
				:label="`${$t('controlPanel.landingPage.label')}`"
				:uploadImageWithClick="uploadImageWithClick"
				:uploadImageWithDrop="uploadImageWithDrop"
				:removeImage="removeImage"
				:apply="apply"
				:allowedFormats="['image/webp']"
				:previewUrl="previewUrl"
				:errors="errors"
			/>
		</section>
		<section class="section">
			<h3 class="title">{{$t('controlPanel.landingPage.newsletterSection')}}</h3>
			<NewsletterManagement />
		</section>
	</div>
</template>

<script>
import ImageUpload from "@/common/components/ImageUpload";
import NewsletterManagement from "@/drc/pages/controlPanel/landingPage/NewsletterManagement";
import * as SERVICES from "@/drc/services/drc-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import * as DrcWebsocketService from "@/common/services/websockets/drc.websocket";
import Hint from "@/common/components/Hint";

export default {
	name: "LandingPagePanel",
	components: {
		ImageUpload,
		Hint,
		NewsletterManagement
	},
	data() {
		return {
			previewUrl: '',
			errors: [],
			imageData: null
		}
	},
	methods: {
		update() {
			DrcWebsocketService.incrementApplicationVersion();
		},
		apply() {
			if (this.errors.length === 0 && this.previewUrl.trim() !== '') {
				SERVICES.uploadLandingPageBackgroundImage(this.imageData, "HOME_IMAGE")
					.then(() => {
						this.showNotification(this.$t(`notifications.successUploadImage`), NOTIFICATION_TYPE.SUCCESS);
						DrcWebsocketService.incrementApplicationVersion(5500);
					})
					.catch((error) => {
						this.showNotification(this.$t(`notifications.serverError`), NOTIFICATION_TYPE.ERROR)
						console.error(error);
					})
					.finally(() => this.imageData = null);
			}
		},
		removeImage() {
			this.previewUrl = "";
			this.errors = [];
		},
		uploadImageWithDrop(event) {
			this.uploadImage(event.dataTransfer.files[0]);
		},
		uploadImageWithClick(event) {
			this.uploadImage(event.target.files[0]);
		},
		uploadImage(file) {
			this.errors = []
			const reader = new FileReader();
			const vue = this;
			reader.onload = (event) => {
				vue.previewUrl = event.target.result;
				const image = new Image();
				image.src = event.target.result;
				image.onload = function () {
					vue.verifyImage(this.height, this.width, vue.fileData.type);
				};
			}

			this.fileData = file;
			if (this.errors.length === 0) {
				reader.readAsDataURL(this.fileData);
				this.imageData = new FormData();
				const fileName = this.parseImageName(this.fileData.name);
				this.imageData.append('files', this.fileData, fileName);
			}
		},
		parseImageName(fileName) {
			fileName = fileName.trim().replaceAll(/\s/g, "-");
			fileName = fileName.replace('%', '-')
			return fileName;
		},
		verifyImage(height, width, type) {
			if (height > 1065 || height < 858) {
				this.errors.push('height')
			}

			if (width > 1728 || width < 1280) {
				this.errors.push('width')
			}

			if (type && type !== "image/webp") {
				this.errors.push('type')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.landing-page-container {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 10vh;

	.section {
		display: flex;
		flex-direction: column;
		gap: 5px;
		border: 1px solid #888;
		padding: 16px;
		border-radius: 4px;

		h3.title{
			margin-bottom: 0px;
		}

		.app-version-button {
			cursor: pointer;
			background-color: #00E7FF;
			padding: 10px 15px;
			border-radius: 4px;
			border: 1px solid #00E7FF;
			text-transform: uppercase;
			width: fit-content;
		}


		.title {
			margin-top: 0;
		}
	}
}
</style>
